import { useCallback } from 'react'
import { useQkNodesResource } from '../../ng-compat/hooks'
import { ApiLayoutData, ApiNode } from './utils/qk-types'

interface DeleteQuickKeyParams {
  layoutData: ApiLayoutData
  node: ApiNode
}

export const useDeleteQuickKey = () => {
  const qkNodesResource = useQkNodesResource()
  const deleteQuickKey = useCallback(
    async ({ node, layoutData }: DeleteQuickKeyParams) => {
      await qkNodesResource.deleteQuickKey(layoutData.id, node.id)
      if (!node.parent_node_id) {
        return [node.id]
      }
      // Check if parent page is empty and if so delete it
      const siblings = layoutData.nodes.filter(
        nodeToCheck =>
          nodeToCheck.parent_node_id === node.parent_node_id &&
          nodeToCheck.id !== node.id
      )

      if (siblings.length === 0) {
        await qkNodesResource.deleteQuickKey(layoutData.id, node.parent_node_id)
        return [node.id, node.parent_node_id]
      }

      return [node.id]
    },
    [qkNodesResource]
  )

  return deleteQuickKey
}
